import React, { FC } from 'react';
import { compose } from 'react-recompose';
import { withTranslation } from 'react-i18next';

import { connect, useSelector } from 'react-redux';

import { push as Push } from 'redux-first-history';
import { useIntercom } from 'react-use-intercom';
import { ForgotPassword } from '@dev/ee-modules';
import { ActivationPayload, ProductCode } from '@dev/ee-api/ee-api-models';

import { useLocation } from 'react-router-dom';
import { ResendActivationEmail } from '@/store/auth/actions';
import { ResetPassword } from '@/store/account/actions';
import { ApplicationState as State } from '@/store';
import { useMobile } from '@/services/hooks/useMobile';

import { getConfigStore } from '@/store/config/types';
import { isCustomBranding } from '@/services/Secuirty';
import { ForgotPasswordProps } from './ForgotPasswordInterface';

type DispatchActions = {
    ResetPassword(email: string): void;
    Push(url: string): void;
    ResendActivationEmail(payload: ActivationPayload): void;
};

type Props = ForgotPasswordProps & DispatchActions;

const dispatchActions = { ResetPassword, Push, ResendActivationEmail };

const mapState = (state: State, ownProps: ForgotPasswordProps): ForgotPasswordProps => ({
    ...ownProps,
    account: state.account,
});

const ForgotPasswordScreen: FC<Props> = ({ ResetPassword, Push, ResendActivationEmail }: Props): JSX.Element => {
    const isMobile = useMobile();
    const location = useLocation();
    const { show } = useIntercom() || {};
    const { isStandalone } = useSelector(getConfigStore);

    const launchIntercom = () => {
        !isCustomBranding() && show();
    };

    return (
        <ForgotPassword
            location={location}
            productCode={isStandalone ? ProductCode.Marketing : ProductCode.Legacy}
            ResetPassword={ResetPassword}
            ResendActivationEmail={ResendActivationEmail}
            Push={Push}
            launchIntercom={launchIntercom}
            isMobile={isMobile}
        />
    );
};

export default compose(
    withTranslation(),
    connect<ForgotPasswordProps, DispatchActions>(mapState, dispatchActions)
)(ForgotPasswordScreen);
